import { appDialogConfirm } from '@components'
import { useAuth, usePotentialHighQuality } from '@stateApp'
import { Archive, CheckCheck, Star, Trash } from 'lucide-solid'
import { Show, createSignal } from 'solid-js'
import { useService } from 'solid-services'
import { Flex } from 'styled-system/jsx'
import { useSingle } from '../../state'
import { SingalPhq } from './SignalPhq'
import { ActionButton } from './ActionButton'

export const AdminActions = (props: { size?: 'admin' | 'mobileAdmin' }) => {
  const size = () => props.size || 'admin'
  const {
    onArchiveSetup,
    onDeleteSetup,
    setupQuery,
    setIsScoreOpen,
    setupPotentialHigQualityQuery,
  } = useService(useSingle)()
  const { canActionPhq } = useService(useAuth)()
  const { confirmPhqMutation } = useService(usePotentialHighQuality)()
  const [isOpen, setIsOpen] = createSignal(false)

  const phqRecord = () => setupPotentialHigQualityQuery.data
  const isPendingPHQ = () => phqRecord() && phqRecord()?.status === 'pending'
  const isConfirmedPHQ = () => phqRecord() && phqRecord()?.status === 'confirmed'

  const onConfirmPhq = () => {
    const currentSetupId = setupQuery?.data?.id
    if (!currentSetupId) return
    appDialogConfirm(
      () => confirmPhqMutation.mutate(currentSetupId, {
        onSuccess: (data) => {
          if (data?.success) {
            setIsScoreOpen(true)
            setupPotentialHigQualityQuery.refetch()
          }
        }
      }),
      'Confirm this setup as Potential High Quality?',
    )()
  }

  return (
    <>
      <SingalPhq
        isOpen={isOpen()}
        setIsOpen={setIsOpen}
      />
      <Flex gap="5px" flexWrap={props.size === 'mobileAdmin' ? 'wrap' : 'nowrap'}>
        <Show when={canActionPhq()}>
          <ActionButton
            size={size()}
            heading={phqRecord() ? 'PHQ Signaled' : 'Signal PHQ'}
            tooltip="Signal Potential High Quality"
            disabled={!!phqRecord()}
            onClick={() => setIsOpen(true)}
            icon={<Star />}
          />
        </Show>
        <Show when={canActionPhq() && isPendingPHQ()}>
          <ActionButton
            size={size()}
            heading={isConfirmedPHQ() ? 'PHQ Confirmed' : 'Confirm PHQ'}
            tooltip="Confirm Potential High Quality"
            disabled={confirmPhqMutation.isPending || !!isConfirmedPHQ()}
            onClick={onConfirmPhq}
            icon={<CheckCheck />}
          />
        </Show>
        <ActionButton
          size={size()}
          heading="Archive"
          tooltip="Archive this setup"
          onClick={appDialogConfirm(
            onArchiveSetup,
            'Are you sure you want to archive this Setup?',
          )}
          icon={<Archive />}
        />
        <ActionButton
          size={size()}
          heading="Delete"
          tooltip="Delete this setup"
          danger
          onClick={appDialogConfirm(
            onDeleteSetup,
            'Are you sure you want to delete this Setup?',
          )}
          icon={<Trash />}
        />
      </Flex>
    </>
  )
}
